export const routePointsSectionListConfig = {
  grid: "15px 1.5fr 100px 1fr 75px 95px 34px 60px",
};
